// Vendored (TypeScript port) from https://github.com/devrafalko/string-math (MIT License)
// Copyright (c) 2017 Paweł Rafałko <dev.rafalko@gmail.com>
//
// Evaluates a string arithmetic expression, e.g. "10+2-1.5" -> 10.5, without eval().
// Throws SyntaxError/TypeError on invalid input.
export function stringMath(eq: string): number {
  if (typeof eq !== 'string') {
    throw new TypeError('The [String] argument is expected.');
  }

  const mulDiv =
    /([+-]?\d*\.?\d+(?:e[+-]\d+)?)\s*([*/])\s*([+-]?\d*\.?\d+(?:e[+-]\d+)?)/;
  const plusMin =
    /([+-]?\d*\.?\d+(?:e[+-]\d+)?)\s*([+-])\s*([+-]?\d*\.?\d+(?:e[+-]\d+)?)/;
  const parentheses = /(\d)?\s*\(([^()]*)\)\s*/;

  let current: string | undefined;
  while (eq.search(/^\s*([+-]?\d*\.?\d+(?:e[+-]\d+)?)\s*$/) === -1) {
    eq = fParentheses(eq);
    if (eq === current) {
      throw new SyntaxError('The equation is invalid.');
    }
    current = eq;
  }
  return +eq;

  function fParentheses(eq: string): string {
    while (eq.search(parentheses) !== -1) {
      eq = eq.replace(
        parentheses,
        (_match: string, b: string | undefined, c: string) => {
          c = fMulDiv(c);
          c = fPlusMin(c);
          return typeof b === 'string' ? b + '*' + c : c;
        }
      );
    }
    eq = fMulDiv(eq);
    eq = fPlusMin(eq);
    return eq;
  }

  function fMulDiv(eq: string): string {
    while (eq.search(mulDiv) !== -1) {
      eq = eq.replace(mulDiv, (match: string) => {
        const sides = mulDiv.exec(match) as RegExpExecArray;
        const result =
          sides[2] === '*' ? +sides[1] * +sides[3] : +sides[1] / +sides[3];
        return result >= 0 ? '+' + result : String(result);
      });
    }
    return eq;
  }

  function fPlusMin(eq: string): string {
    eq = eq.replace(
      /([+-])([+-])(\d|\.)/g,
      (_match: string, b: string, c: string, d: string) =>
        (b === c ? '+' : '-') + d
    );
    while (eq.search(plusMin) !== -1) {
      eq = eq.replace(plusMin, (match: string) => {
        const sides = plusMin.exec(match) as RegExpExecArray;
        return String(
          sides[2] === '+' ? +sides[1] + +sides[3] : +sides[1] - +sides[3]
        );
      });
    }
    return eq;
  }
}
